module.exports = __webpack_public_path__ + "static/media/location.b43582f9.svg";